<body>
  <header class="flex justify-center items-center">
    <img src="cb-logo.svg" />
  </header>
  <main class="loan-page signup-main">
    <h1>Sign Up</h1>
    <div class="signup-columns">
      <div class="signup-top-row">
        <div class="loan-section max-w-400 w-full">
          <app-loan-input label="Email" [control]="usernameControl" />
          <app-loan-input label="Full name" [control]="fullNameControl" />
          <app-loan-input label="Password" [control]="passwordControl" type="password" [enableVisibilityToggle]="true" />
          <app-loan-input label="Repeat Password" [control]="repeatPasswordControl" type="password" [enableVisibilityToggle]="true" />

          <!-- <app-loan-checkbox class="px-20" text="Keep me signed in" groupName="Signin" [control]="keepControl" /> -->
        </div>

        <aside class="loan-section max-w-400 w-full online-banking-cta" aria-label="Online banking sign-in">
          <p class="online-banking-cta__title">Already use online banking?</p>
          <p class="online-banking-cta__body">
            You can access the commercial loan application from Central Bank online banking after you sign in.
          </p>
          <a class="online-banking-cta__button" [href]="onlineBankingUrl" target="_blank" rel="noopener noreferrer">
            Log in to online banking
          </a>
        </aside>
      </div>

      <div class="signup-legal-row">
        <div class="esign-disclosure">
          <p class="esign-disclosure__text">
            By selecting “I Agree,” you consent to receive all disclosures, agreements, notices, and other records related to your
            application and transaction with Central Bank in electronic form rather than in paper form, and you agree that your electronic
            signature is the legal equivalent of your handwritten signature under the federal Electronic Signatures in Global and National
            Commerce Act (ESIGN) and the Utah Uniform Electronic Transactions Act (UETA). You acknowledge that you have the ability to access
            and retain electronic documents, including PDF files, using a device with internet access and a current web browser, and that you
            can download or print copies for your records. You understand that you have the right to request paper copies of any document and
            may withdraw your consent to receive electronic records at any time by contacting us at
            <a [href]="'tel:+18013751000'">{{ contactPhone }}</a> or visiting
            <a [href]="contactUrl" target="_blank" rel="noopener noreferrer">our contact page</a>, although withdrawal will not affect the
            validity of documents previously signed and may delay or prevent completion of your transaction. You agree to provide and maintain
            a valid email address for delivery of electronic records and confirm that you are authorized to act on behalf of the applicant
            or business entity, if applicable.
          </p>
        </div>

        <div class="loan-section">
          <app-loan-checkbox text="I Agree" groupName="esignConsent" [control]="esignConsentControl" />

          <div class="flex justify-between items-center">
            <app-button (click)="signup()">Sign Up</app-button>
            <p class="text-err">{{ err }}</p>
          </div>
          @if (msg) {
            <p class="pt-10">{{ msg }}</p>
          }
        </div>
      </div>
    </div>
  </main>
</body>
